"use strict";

import { lcvPrizePotConstants } from "../_constants/lcvPrizePot.constants";

export const lcvPrizePotGetRequest = (payload) => {
     return {
          type: lcvPrizePotConstants.LCV_PRIZE_POT_GET_REQUEST,
          payload,
     };
};

export const lcvPrizePotGetComplete = (payload) => {
     return {
          type: lcvPrizePotConstants.LCV_PRIZE_POT_GET_COMPLETE,
          payload,
     };
};

export const lcvPrizePotSetAvailabilityRequest = (payload) => {
     return {
          type: lcvPrizePotConstants.LCV_PRIZE_POT_SET_AVAILABILITY_REQUEST,
          payload,
     };
};

export const lcvPrizePotSetAvailabilityComplete = (payload) => {
     return {
          type: lcvPrizePotConstants.LCV_PRIZE_POT_SET_AVAILABILITY_COMPLETE,
          payload,
     };
};

export const lcvPrizePotIncreaseQuantityRequest = (payload) => {
     return {
          type: lcvPrizePotConstants.LCV_PRIZE_POT_INCREASE_QUANTITY_REQUEST,
          payload,
     };
};

export const lcvPrizePotIncreaseQuantityComplete = (payload) => {
     return {
          type: lcvPrizePotConstants.LCV_PRIZE_POT_INCREASE_QUANTITY_COMPLETE,
          payload,
     };
};

export const lcvPrizePotClearActionResult = () => {
     return {
          type: lcvPrizePotConstants.LCV_PRIZE_POT_CLEAR_ACTION_RESULT,
     };
};

export const lcvPrizePotGetBudgetActivityRequest = (payload) => {
     return {
          type: lcvPrizePotConstants.LCV_PRIZE_POT_GET_BUDGET_ACTIVITY_REQUEST,
          payload,
     };
};

export const lcvPrizePotGetBudgetActivityComplete = (payload) => {
     return {
          type: lcvPrizePotConstants.LCV_PRIZE_POT_GET_BUDGET_ACTIVITY_COMPLETE,
          payload,
     };
};

export const lcvPrizePotAddBudgetEntryRequest = (payload) => {
     return {
          type: lcvPrizePotConstants.LCV_PRIZE_POT_ADD_BUDGET_ENTRY_REQUEST,
          payload,
     };
};

export const lcvPrizePotAddBudgetEntryComplete = (payload) => {
     return {
          type: lcvPrizePotConstants.LCV_PRIZE_POT_ADD_BUDGET_ENTRY_COMPLETE,
          payload,
     };
};
